import { ReactElement } from "react";

import { Chip } from "@mui/material";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import { SxProps, Theme } from "@mui/material/styles";

import sidebarStyles from "./sidebarStyles";

interface ISidebarItemProperties {
  icon: ReactElement;
  isComingSoon?: boolean;
  isSelected: boolean;
  isSidebarOpen: boolean;
  label: string;
  onClick: () => void;
  sx?: SxProps<Theme>;
}

/**
 * A navigation item with an icon and label.
 *
 * @param icon - icon to display for item.
 * @param label - text to display for item.
 * @param onClick - callback function when the item is clicked.
 * @param selected - boolean whether the item is selected.
 */
export default function NavItem({
  icon,
  isComingSoon,
  isSelected,
  isSidebarOpen,
  label,
  onClick,
  sx,
}: ISidebarItemProperties) {
  return (
    <MenuItem
      disabled={isComingSoon}
      disableRipple
      onClick={onClick}
      selected={isSelected}
      sx={{
        ...sidebarStyles.menuItem,
        ...sx,
      }}
    >
      <Box
        className="menu-item-wrapper"
        sx={{
          "& > span": {
            // display: "none",
            opacity: isSidebarOpen ? 1 : 0,
            transition: "opacity 0.3s ease-in-out",
          },
        }}
      >
        <Box className="svg-wrapper">{icon}</Box>
        <span>{label}</span>
        {isComingSoon && (
          <Chip
            label="Coming Soon"
            size="small"
            sx={{ color: "white", fontSize: "10px", marginLeft: 1, opacity: 0.6 }}
            variant="outlined"
          />
        )}
      </Box>
    </MenuItem>
  );
}
